import React, { Component } from 'react';
import Formulario from './FormSeleccionarPais';
import { Redirect } from 'react-router-dom';

class SeleccionarPais extends Component{

    componentDidMount = () => {
        const { paisList } = this.props;
        paisList();
    }
    render(){
        const { pais } = this.props;
        let ruta = window.location.href;
        let id_emp = ruta.split('/');
        return(
            pais.length >= 2 ? (
                <Formulario
                    pais={pais}
                />
            ) : (
                <React.Fragment>
                    {
                        pais.map((p) => 
                            <Redirect to={`/visitador_medico/${id_emp[5]}/visitador/${p.value}`} />
                        )
                    }
                </React.Fragment>
            )
        );
    } 
}

export default SeleccionarPais;